import react from "react";
import "./Footer.css";
import { Link } from "react-router";

function Footer(){
    return(
        <footer>
            <p>&copy; 2025 Berimbolo Security, Inc. All rights reserved</p>
        </footer>
    )
}

export default Footer;